/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Review_HintInputs */

const cs_property_ai_review_hint = /** @type {(inputs: Property_Ai_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI překlady zůstávají označené jako strojové, dokud je nezkontrolujete v editačním formuláři.`)
};

const en_property_ai_review_hint = /** @type {(inputs: Property_Ai_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI translations stay marked as machine-made until you review them in the edit form.`)
};

/**
* | output |
* | --- |
* | "AI translations stay marked as machine-made until you review them in the edit form." |
*
* @param {Property_Ai_Review_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_review_hint = /** @type {((inputs?: Property_Ai_Review_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Review_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_review_hint(inputs)
	return cs_property_ai_review_hint(inputs)
});